import { render, staticRenderFns } from "./CrearProcedimiento.vue?vue&type=template&id=e416a62e&"
import script from "./CrearProcedimiento.vue?vue&type=script&lang=js&"
export * from "./CrearProcedimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports